import { createCaches } from '@webapp2/shared/services/cache'

const caches = createCaches('OssoVR', 7, ['organization', 'admin'])

export const cache = caches.organization
export const adminCache = caches.admin
